import { RefObject, useEffect, useRef } from 'react';

export const useScrollingClass = (ref: RefObject<HTMLElement>, className: string) => {
  const didMount = useRef(false);
  const isScrolled = useRef(false);

  // TODO: should throttle this to prevent layout thrashing
  const handleScroll = () => {
    const nextIsScrolled = ref.current?.scrollTop > 0;

    if (nextIsScrolled == isScrolled.current) {
      return;
    }

    if (nextIsScrolled) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }

    isScrolled.current = nextIsScrolled;
  };

  useEffect(() => {
    if (!didMount.current && ref.current) {
      handleScroll();
      ref.current.addEventListener('scroll', handleScroll);
      didMount.current = true;
    }

    if (ref.current) {
      return () => {
        document.body.classList.remove(className);
        ref.current?.removeEventListener?.('scroll', handleScroll);
      };
    } else {
      return () => {};
    }
  }, [ref]);
};
